// extracted by mini-css-extract-plugin
var _1 = "Submit-MIjRt";
var _2 = "SubmitButton-L_ZS2";
var _3 = "SubmitText-EcB4d";
export { _1 as "Submit", _2 as "SubmitButton", _3 as "SubmitText" }
